'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { SwanFonts } from './fonts.component.js';
import { SwanPageMeta } from './page-meta.component.js';
import { SwanStylesheets } from './stylesheets.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(o = 0; o < s.length; o++)r = s[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, s = Object.keys(e);
    for(o = 0; o < s.length; o++)r = s[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const SwanHead = (p)=>{
    var { fontNames: c, styleSheetKeys: i, renderStyleContentAsChildren: l } = p, a = _object_without_properties(p, [
        "fontNames",
        "styleSheetKeys",
        "renderStyleContentAsChildren"
    ]);
    return jsxs(Fragment, {
        children: [
            jsx(SwanPageMeta, _object_spread({}, a)),
            jsx(SwanFonts, _object_spread({
                fontNames: c,
                renderStyleContentAsChildren: l
            }, a)),
            jsx(SwanStylesheets, _object_spread({
                styleSheetKeys: i
            }, a))
        ]
    });
};

export { SwanHead };
